import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: "Clash Grotesk Medium";
  src: url("../fonts/ClashGrotesk-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Clash Grotesk Regular";
  src: url("../fonts/ClashGrotesk-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Clash Grotesk Semibold";
  src: url("../fonts/ClashGrotesk-Semibold.woff") format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

  :root {
    --green: #0ac2a7;
    --blue: #027ef2;
    --purple: #71427b;
    --orange: #fe653e;
    --white: #ffffff;
    --grey: #757575;
    --light-grey: #dbdbdb;
    --black: #0f1010;
    --faded-green: #d3efea;
    --faded-blue: #027ef226;
    --faded-purple: #e2d8e4;
    --faded-orange: #ffdfd7;
    --background-grey: #f7f7f6;

    --font-family-regular: "Clash Grotesk Regular";
    --font-family-semibold: "Clash Grotesk Semibold";
    --font-family-medium: "Clash Grotesk Medium";
    --font-style-normal: normal;
    --font-weight-600: 600;
    --font-weight-normal: normal;
    --font-weight-medium: medium;
    --font-weight-bold: bold;
    --font-size-14: 14px;
    --font-size-16: 16px;
    --font-size-17: 17px;
    --font-size-18: 18px;
    --font-size-20: 20px;
    --font-size-22: 22px;
    --font-size-25: 25px;
    --font-size-30: 30px;
    --font-size-35: 35px;
    --font-size-40: 40px;
    --font-size-45: 45px;
    --font-size-60: 60px;
    --font-size-64: 64px;
    --font-size-75: 75px;
    --font-size-80: 80px;
    --font-size-22-5: 22.5px;
    --character-spacing-0: 0px;
    --line-spacing-20: 20px;
    --line-spacing-25: 25px;
    --line-spacing-30: 30px;
    --line-spacing-35: 35px;
    --line-spacing-40: 40px;
    --line-spacing-45: 45px;
    --line-spacing-50: 50px;
    --line-spacing-65: 65px;
    --line-spacing-70: 70px;
    --line-spacing-75: 75px;
    --line-spacing-95: 95px;
    --line-spacing-32-5: 32.5px;
  }

  *, html {
    box-sizing: border-box;
  }

  body {
    padding: 0;
    margin: 0;
    font-family: var(--font-family-regular);
    font-style: var(--font-style-normal);
    font-size: var(--font-size-18);
    line-height: var(--line-spacing-25);
    letter-spacing: var(--character-spacing-0);
    color: var(--black);
    background-color: var(--background-grey);
    min-height: 100vh;
  }


  h1 {
    font-size: var(--font-size-30);
    line-height: var(--line-spacing-40);
  }

  h2 {
    font-size: var(--font-size-25);
    line-height: var(--line-spacing-30);
  }

  h3 {
    font-size: var(--font-size-20);
    line-height: var(--line-spacing-20);
    
  }

  h4 {
    font-size: var(--font-size-15);
    line-height: var(--line-spacing-20);
  }

  .cookies {
    color: var(--white);
  }

  @media (min-width: 768px) {
  
    h1 {
      font-size: var(--font-size-45);
      line-height: var(--line-spacing-50);
    }
  
    h2 {
      font-size: var(--font-size-35);
      line-height: var(--line-spacing-40);
    }

    h3 {
      font-size: var(--font-size-25);
      line-height: var(--line-spacing-30);
      
    }
  
    h4 {
      font-size: var(--font-size-20);
      line-height: var(--line-spacing-25);
    }
  }
`;

export default GlobalStyle;
